import Drawer from 'components/Drawer'
import ArticleIcon from 'components/icons/ArticleIcon'
import BlueArrowIcon from 'components/icons/BlueArrowIcon'
import CalenderAddIcon from 'components/icons/CalenderAddIcon'
import ScheduleInterview from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/index'
import React, { useState } from 'react'

import ReleaseOffer from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ReleaseOfferDrawer/index'
import {
  ContentDiv,
  MainFlex,
  TiltleDiv,
  TitleFlex,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/Style/style'

const BulkActionDrawer = ({
  bulkAction,
  setBulkAction,
  setScheduleDrawer,
  scheduleDrawer,
  releaseOffer,
  setReleaseOffer,
  selectedCandidateId,
  selectedCandidate,
  rolesMetrics,
  createInterview,
  driveId,
  roleId,
  driveInterViewerList,
  getDriveInterviewerList,
  selectedRound,
  driveData,
  selectedRoundType,
  candidateDeatils,
  candidateInfoData,
  getCandidateList,
  getRoleMetrics,
  setSelectedCandidateId,
  setSelectedCandidate,
  getCities,
  cityList,
  releaseOfferAPI,
  stage,
  singleRoleData,
  tabNames,
  status,
  getNewDriveFreshersList,
  lastPanelId,
  isAllSelected,
  setIsAllSelected,
}) => {
  const isSingleOrBulk = selectedCandidate?.length > 1
  const [isConfirm, setIsConfirm] = useState(false)
  const [newForm, setNewForm] = useState(true)

  const handleBulkActionChange = action => {
    if (action == 'schedule') {
      setBulkAction(false)
      setScheduleDrawer(true)
    }

    if (action == 'relese') {
      setBulkAction(false)
      setReleaseOffer(true)
    }
  }

  const bulkOptions = [
    {
      key: 'schedule',
      title: 'Schedule Interview',
      titleInfo: '',
      icon: <CalenderAddIcon />,
    },
    {
      key: 'relese',
      title: 'Release Intent to Offer',
      titleInfo: '',
      icon: <ArticleIcon />,
    },
  ]

  const content = () => {
    return (
      <>
        {bulkOptions?.map((item, index) => (
          <MainFlex
            key={index + item?.title}
            spaceBetween
            centerVertically
            row
            center
            onClick={() => handleBulkActionChange(item?.key)}
            disable={
              item?.key === 'relese' ? stage !== 'offer' : stage === 'offer'
            }
          >
            <TitleFlex column>
              <TitleFlex centerVertically>
                {item.icon}
                <TiltleDiv>{item.title}</TiltleDiv>
              </TitleFlex>
              <ContentDiv>{item.titleInfo}</ContentDiv>
            </TitleFlex>
            <BlueArrowIcon />
          </MainFlex>
        ))}
      </>
    )
  }
  return (
    <>
      <Drawer
        width="40%"
        title={'Bulk Action'}
        placement="right"
        visible={bulkAction}
        content={content()}
        onClose={() => {
          setBulkAction(false)
        }}
        closable
      />

      <ScheduleInterview
        lastPanelId={lastPanelId}
        setScheduleDrawer={setScheduleDrawer}
        scheduleDrawer={scheduleDrawer}
        selectedCandidateId={selectedCandidateId}
        selectedCandidate={selectedCandidate}
        rolesMetrics={rolesMetrics}
        createInterview={createInterview}
        driveId={driveId}
        roleId={roleId}
        driveInterViewerList={driveInterViewerList}
        getDriveInterviewerList={getDriveInterviewerList}
        selectedRound={selectedRound}
        driveData={driveData}
        selectedRoundType={selectedRoundType}
        candidateDeatils={candidateDeatils}
        candidateInfoData={candidateInfoData}
        getCandidateList={getCandidateList}
        getRoleMetrics={getRoleMetrics}
        setSelectedCandidateId={setSelectedCandidateId}
        setSelectedCandidate={setSelectedCandidate}
        isSingleOrBulk={isSingleOrBulk}
        newForm={newForm}
        setnewForm={setNewForm}
        singleRoleData={singleRoleData}
        stage={stage}
        status={status}
        getCandidateScoreList={getNewDriveFreshersList}
        isAllSelected={isAllSelected}
        setIsAllSelected={setIsAllSelected}
      />

      {(releaseOffer || isConfirm) && (
        <ReleaseOffer
          releaseOffer={releaseOffer}
          setReleaseOffer={setReleaseOffer}
          selectedCandidate={selectedCandidate}
          candidateDeatils={candidateDeatils}
          isSingleOrBulk={isSingleOrBulk}
          getCities={getCities}
          cityList={cityList}
          releaseOfferAPI={releaseOfferAPI}
          driveId={driveId}
          roleId={roleId}
          selectedCandidateId={selectedCandidateId}
          setSelectedCandidate={setSelectedCandidate}
          setSelectedCandidateId={setSelectedCandidateId}
          rolesMetrics={rolesMetrics}
          singleRoleData={singleRoleData}
          getCandidateList={getCandidateList}
          isConfirm={isConfirm}
          setIsConfirm={setIsConfirm}
          driveData={driveData}
          tabNames={tabNames}
          isBulk={
            selectedCandidate?.length === 10 ||
            selectedCandidate?.length === candidateDeatils?.count
          }
        />
      )}
    </>
  )
}

export default BulkActionDrawer
